import { TAXONOMY } from '../../common/constants';
import MapIconPink from '../../icons/map-icon-pink.svg';
import MapIconOrange from '../../icons/map-icon-orange.svg';
import MapIconGreen from '../../icons/map-icon-green.svg';
import MapIconYellow from '../../icons/map-icon-yellow.svg';

export const transformMapData = (impactLitters, filter = TAXONOMY.OBJECT) => {
    if (impactLitters && impactLitters.length) {
        return impactLitters.map((litter) => {
            return {
                id: litter.id,
                position: {
                    lat: parseFloat(JSON.parse(litter.location).y),
                    lng: parseFloat(JSON.parse(litter.location).x),
                },
                icon: getFilterIcon(filter),
                thumbnail: litter.thumbnail || null,
                tags: litter.tags,
            };
        });
    } else {
        return [];
    }
};

function getFilterIcon(filter) {
    switch (filter) {
        case TAXONOMY.OBJECT:
            return MapIconPink;
        case TAXONOMY.BRAND:
            return MapIconOrange;
        case TAXONOMY.CATEGORY:
            return MapIconGreen;
        case TAXONOMY.MATERIAL:
            return MapIconYellow;
        default:
            return MapIconOrange;
    }
}
